import React from 'react';

interface MusicFileIconProps {
  width?: number;
  height?: number;
}

export const MusicFileIcon: React.FC<MusicFileIconProps> = ({
  width = 16,
  height = 16,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.7533 4.41875V14.0719C13.7533 15.1375 12.8908 16 11.8252 16H4.1752C3.10957 16 2.24707 15.1375 2.24707 14.0719V1.92813C2.24707 0.8625 3.10957 0 4.1752 0H9.33457L13.7533 4.41875Z"
      fill="#F59E0B"
    />
    <path
      d="M13.7527 4.41875H10.1309C9.69023 4.41875 9.33398 4.0625 9.33398 3.62188V0L13.7527 4.41875Z"
      fill="#FDE68A"
    />
    <g clipPath="url(#clip0_37996_64145)">
      <path
        d="M5.53323 12.2926C5.60188 12.5488 5.76947 12.7672 5.99916 12.8998C6.22884 13.0324 6.5018 13.0683 6.75798 12.9997C7.01416 12.931 7.23258 12.7635 7.36518 12.5338C7.49779 12.3041 7.53373 12.0311 7.46508 11.7749C7.39644 11.5188 7.22884 11.3003 6.99916 11.1677C6.76947 11.0351 6.49652 10.9992 6.24034 11.0678C5.98416 11.1365 5.76574 11.3041 5.63313 11.5338C5.50053 11.7635 5.46459 12.0364 5.53323 12.2926Z"
        stroke="white"
        strokeWidth="0.666667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75296 11.4299C8.8216 11.686 8.9892 11.9045 9.21889 12.0371C9.44857 12.1697 9.72153 12.2056 9.9777 12.137C10.2339 12.0683 10.4523 11.9007 10.5849 11.671C10.7175 11.4414 10.7535 11.1684 10.6848 10.9122C10.6162 10.656 10.4486 10.4376 10.2189 10.305C9.9892 10.1724 9.71625 10.1365 9.46007 10.2051C9.20389 10.2738 8.98547 10.4414 8.85286 10.671C8.72025 10.9007 8.68432 11.1737 8.75296 11.4299Z"
        stroke="white"
        strokeWidth="0.666667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.4653 11.7749L6.34375 7.58926L9.5635 6.72653L10.6851 10.9122"
        stroke="white"
        strokeWidth="0.666667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.68848 8.87717L9.90823 8.01444"
        stroke="white"
        strokeWidth="0.666667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_37996_64145">
        <rect
          width="8"
          height="8"
          fill="white"
          transform="translate(3.10059 7.07782) rotate(-15)"
        />
      </clipPath>
    </defs>
  </svg>
);
